import script from "./PDFTierView.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFTierView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__